import { render, staticRenderFns } from "./CompanyEnvironment.vue?vue&type=template&id=dec197de&"
import script from "./CompanyEnvironment.vue?vue&type=script&lang=js&"
export * from "./CompanyEnvironment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports